/**
 * @author Yashwitha
 * @Date: 2024-01-29 13:05:06
 */

import React, { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Form, Breadcrumb, Card, Divider, Select, Button, Checkbox } from 'antd';

import { AppWrappperHOC } from '../Root/HOC';
import { constants, utils, validationRules } from '../../devUtils';
// import Container from '../../components/Container';
import { ZaggleCard } from '../NetworkCards/StyledNetworkCard';
import { StyledYblMinKyc } from '../YblMinKyc/StyledYblMinKyc';
import { YblMinKycExistingUsersPropTypes, YblMinKycExistingUsersmapDispatchToProps, YblMinKycExistingUsersmapStateToProps } from './YblMinKycExistingUsersDataHandler';
import { aadharConsent } from './constants';
import { Container } from '../../components';

const { Option } = Select;
const { Item } = Breadcrumb;
const { aadharConsentTextYbl } = aadharConsent;

class YblMinKycExistingUsers extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      consent: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const {
      onKycStaticData,
    } = this.props;
    onKycStaticData();
  }

  componentWillReceiveProps(nextProps) {
    const {
      YblMinKycExistingUsersSuccess: _YblMinKycExistingUsersSuccess,
      history,
      onFetchWalletBalance,
      WalletBalance: _WalletBalance,
    } = this.props;
    const {
      YblMinKycExistingUsersSuccess, YblMinKycExistingUsersSuccess: { status },
      WalletBalance, WalletBalance: { status: wallet_balance_status },
    } = nextProps;
    if (!utils.isEqual(YblMinKycExistingUsersSuccess, _YblMinKycExistingUsersSuccess) && status) {
      onFetchWalletBalance({}, { cardType: 'yesBank' });
    } else if (!utils.isEqual(WalletBalance, _WalletBalance) && wallet_balance_status) {
      utils.forceRedirect(history, { pathname: constants.LINK_PAY_BALANCE });
    }
  }

  handleSubmit(evt) {
    evt.preventDefault();
    const {
      form: {
        validateFields,
      },
      onYesBankMinKycExistingUsers,
    } = this.props;
    validateFields((err, values) => {
      if (!err) {
        const {
          profession = '',
          education_qualification = '',
          annual_income = '',
          source_of_fund = '',
          self_employed_profession = '',
          nature_of_business = '',
        } = values;
        const payload = {
          profession,
          education_qualification,
          annual_income,
          source_of_fund,
          self_employed_profession,
          nature_of_business,
          user_consent: 'Yes',
        };
        onYesBankMinKycExistingUsers(payload);
      }
    });
  }

  renderYblMinKycExistingUsersPage() {
    const {
      form:
      {
        getFieldDecorator,
        getFieldValue,
      } = {},
      KycStaticData: {
        response: {
          annual_income_options = [],
          education_options = [],
          nature_of_business_options = [],
          profession_options = [],
          self_employed_profession_options = [],
          source_of_fund_options = [],
        } = {},
      } = {},
      isLoadingStatus,
    } = this.props;
    const {
      consent,
    } = this.state;
    return (
      <Row align="middle" type="flex" gutter={20}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <strong className="font-18">Profile Information</strong>
          <Divider />
          <StyledYblMinKyc>
            <Form
              onSubmit={this.handleSubmit}
              layout="vertical"
            >
              <Row align="middle" type="flex" justify="start" gutter={20}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Row align="middle" type="flex" justify="start" gutter={30}>
                  </Row>
                  <Row align="middle" type="flex" justify="start" gutter={30}>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Form.Item label="Profession">
                        {getFieldDecorator('profession', {
                          rules: [validationRules.mandatory],
                        })(
                          <Select placeholder="Select Profession">
                            {profession_options && profession_options.length && profession_options.map(({ name = '', value = '' }) => (
                              <Option key={value} value={value}>{name}</Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Form.Item label="Qualification">
                        {getFieldDecorator('education_qualification', {
                          rules: [validationRules.mandatory],
                        })(
                          <Select placeholder="Select Education Qualification">
                            {education_options && education_options.length && education_options.map(({ name = '', value = '' }) => (
                              <Option key={value} value={value}>{name}</Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Form.Item label="Annual Income">
                        {getFieldDecorator('annual_income', {
                          rules: [validationRules.mandatory],
                        })(
                          <Select placeholder="Select Annual Income">
                            {annual_income_options && annual_income_options.length && annual_income_options.map(({ name = '', value = '' }) => (
                              <Option key={value} value={value}>{name}</Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row align="middle" type="flex" justify="start" gutter={30}>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Form.Item label="Source of Funds">
                        {getFieldDecorator('source_of_fund', {
                          rules: [validationRules.mandatory],
                        })(
                          <Select placeholder="Select Source of Funds">
                            {source_of_fund_options && source_of_fund_options.length && source_of_fund_options.map(({ name = '', value = '' }) => (
                              <Option key={value} value={value}>{name}</Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                    {getFieldValue('profession') === 'SELF-EMPLOYED' ?
                      <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                        <Form.Item label="Self Employeed Profession">
                          {getFieldDecorator('self_employed_profession', {
                            rules: [validationRules.mandatory],
                          })(
                            <Select placeholder="Select Self Employeed Profession">
                              {self_employed_profession_options && self_employed_profession_options.length && self_employed_profession_options.map(({ name = '', value = '' }) => (
                                <Option key={value} value={value}>{name}</Option>
                              ))}
                            </Select>
                          )}
                        </Form.Item>
                      </Col> : ''}
                    {getFieldValue('profession') === 'BUSINESS' ?
                      <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                        <Form.Item label="Nature of Business">
                          {getFieldDecorator('nature_of_business', {
                            rules: [validationRules.mandatory],
                          })(
                            <Select placeholder="Select Nature of Business">
                              {nature_of_business_options && nature_of_business_options.length && nature_of_business_options.map(({ name = '', value = '' }) => (
                                <Option key={value} value={value}>{name}</Option>
                              ))}
                            </Select>
                          )}
                        </Form.Item>
                      </Col> : '' }
                  </Row>
                  <Row align="middle" type="flex" justify="start" gutter={10}>
                    <Checkbox
                      checked={consent}
                      onChange={({ target: { checked } }) => this.setState({ consent: checked })}
                    >
                      {aadharConsentTextYbl}
                    </Checkbox>
                  </Row>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-right margin-t-4">
                  <Button
                    className="width-2"
                    href={constants.LINK_PAY_BALANCE}
                  >
                    Cancel
                  </Button>
                  <Button
                    htmlType="submit"
                    className="margin-l-2 green-btn width-2"
                    disabled={!consent}
                    loading={isLoadingStatus}
                  >
                    Submit
                  </Button>
                </Col>
              </Row>
            </Form>
          </StyledYblMinKyc>
        </Col>
      </Row>
    );
  }

  render() {
    return (
      <div>
        <br clear="all" />
        <Fragment>
          <Container>
            <ZaggleCard>
              <Row align="middle" type="flex" gutter={24} className="margin-t-2">
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <h1>Manage Zaggle Cards</h1>
                  <Breadcrumb separator="<" className="margin-b-2 font-12 custom-breadcrumb">
                    <Item href={constants.LINK_MY_PROFILE} className="crumb-link">My Account</Item>
                    <Item href={constants.LINK_PAY_BALANCE} className="crumb-link">Manage Cards</Item>
                    <Item>Yes Bank Kyc Existing Users</Item>
                  </Breadcrumb>
                </Col>
              </Row>
              <Card className="rounded card-padding-20 noborder margin-b-1">
                {this.renderYblMinKycExistingUsersPage()}
              </Card>
            </ZaggleCard>
          </Container>
        </Fragment>
      </div>
    );
  }
}

YblMinKycExistingUsers.propTypes = YblMinKycExistingUsersPropTypes;

const YblMinKycExistingUsersWrapper = Form.create({ name: 'normal_admin' })(YblMinKycExistingUsers);
export default connect(YblMinKycExistingUsersmapStateToProps, YblMinKycExistingUsersmapDispatchToProps)(AppWrappperHOC(YblMinKycExistingUsersWrapper));
export { YblMinKycExistingUsers, YblMinKycExistingUsersWrapper };



// WEBPACK FOOTER //
// client/containers/YblMinKycExistingUsers/index.js